export const techSkills = ["Flutter", "Bloc", "Firebase", "Api"];
